import el from 'element-ui/src/locale/lang/el';
import { trIdReg } from '@/util/util';
let validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入译员ID'));
  } else if (value.search(trIdReg) < 0) {
    callback(new Error('译员ID格式有误'));
  } else if (value.length > 32) {
    callback(new Error('译员ID长度超过32个字符'));
  } else {
    callback();
  }
};
export const tableOption = {
  border: true,
  // index: true,
  // indexLabel: '序号',
  delBtn: false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: true,
  searchMenuSpan: 6,
  showClomnuBtn: false,
  searchSize: 'mini',
  // menuWidth: 300,
  addBtn: true,
  editBtn: false,
  viewBtn: false,
  selection: true,
  reserveSelection: true,
  props: {
    label: 'label',
    value: 'value',
  },
  column: [
    {
      label: '',
      labelWidth: 40,
      type: 'text',
      params: {
        html: '<span>可信度划分:高（80-100），中（60-80），低（40-60），不可信（40及以下）</span>',
        contentPosition: 'left',
      },
      hide: true,
    },
    {
      label: '译员ID',
      labelWidth: 100,
      width: 270,
      prop: 'id',
      row: true,
      search: true,
      editDisabled: true,
      rules: [
        {
          validator: validatePass,
          trigger: 'blur',
        },
      ],
      span: 24,
    },
    {
      label: '译员昵称/姓名',
      labelWidth: 110,
      width: 140,
      prop: 'nickName',
      searchLabelWidth: 1,
      row: true,
      addDisplay: false,
      editDisplay: false,
      search: true,
    },
    {
      label: 'PE权限',
      editDisplay: false,
      prop: 'peStatus',
      value: 1,
      rules: [
        {
          required: true,
          message: '请选择PE权限',
          trigger: 'blur',
        },
      ],
      type: 'switch',
      activeColor: '#ff4949',
      inactiveColor: '#13ce66',
      dicData: [
        {
          label: '启用',
          value: 1,
        },
        {
          label: '禁用',
          value: 2,
        },
      ],
      formslot: true,
    },
    {
      label: 'PE信用分',
      editDisplay: false,
      type: 'number',
      minRows: 1,
      maxRows: 100,
      rules: [
        {
          required: true,
          message: '请输入PE信用分',
          trigger: 'blur',
        },
      ],
      row: true,
      span: 24,
      prop: 'pePointInt',
    },
    {
      label: 'PE可信度',
      addDisplay: false,
      editDisplay: false,
      row: true,
      prop: 'peLevel',
    },
    {
      label: 'PE分值',
      minRows: 1,
      maxRows: 100,
      addDisplay: false,
      labelWidth: 100,
      type: 'number',
      row: true,
      prop: 'pePoint',
      hide: true,
      span: 24,
    },
    {
      label: '更新分值原因',
      labelWidth: 110,
      row: true,
      type: 'textarea',
      prop: 'remark',
      hide: true,
      rules: {
        required: true,
        message: '请输入更新分值原因',
        trigger: 'blur',
      },
      span: 24,
    },
  ],
};
